import { OktonInput, OktonSelect } from '@okton/platform-ui';
import { Box, SimpleGrid } from '@chakra-ui/react';
import React from 'react';

export const SecaoPrecoEstoque = ({
  dadosFormulario,
  lidarComMudancaInput,
}) => {
  return (
    <SimpleGrid columns={{ base: 1, md: 2 }} spacing={4}>
      <OktonInput
        name="preco"
        label="Preço *"
        required
        value={dadosFormulario.preco}
        pl="10"
        size="sm"
        leftElement="R$"
        onChange={lidarComMudancaInput}
      />

      <OktonInput
        name="precoPromocional"
        label="Preço Promocional"
        value={dadosFormulario.precoPromocional}
        pl="10"
        size="sm"
        leftElement="R$"
        onChange={lidarComMudancaInput}
      />

      <OktonInput
        name="estoqueTotal"
        label="Estoque Total *"
        required
        value={dadosFormulario.estoqueTotal}
        size="sm"
        onChange={lidarComMudancaInput}
      />

      <OktonInput
        name="estoqueReservado"
        label="Estoque Reservado"
        value={dadosFormulario.estoqueReservado}
        size="sm"
        onChange={lidarComMudancaInput}
      />

      <Box gridColumn={{ md: 'span 2' }}>
        <OktonSelect
          name="unidadeMedida"
          label="Unidade de Medida"
          value={dadosFormulario.unidadeMedida}
          size="sm"
          onChange={lidarComMudancaInput}
          options={[
            { value: 'Unidade (UN)', label: 'Unidade (UN)' },
            { value: 'Par (PR)', label: 'Par (PR)' },
          ]}
        />
      </Box>
    </SimpleGrid>
  );
};
